import Survay from './Survay';
import withStyles from 'react-jss';
import styles from './styles';
import { bindActionCreators } from 'redux';
import { initSurvay } from './ducks/actions';
import { connect } from 'react-redux';
var mapStateToProps = function (state) {
    return {
        survays: state.survay.survays,
        page: state.survay.page
    };
};
var mapDistpatchToProps = function (dispatch) {
    return bindActionCreators({
        initSurvay: initSurvay,
    }, dispatch);
};
export default withStyles(styles)(connect(mapStateToProps, mapDistpatchToProps)(Survay));



//////////////////
// WEBPACK FOOTER
// ./src/pages/Survay/index.tsx
// module id = 1369
// module chunks = 0